import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import { useStore } from "../../app/stores/store";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";
import Pagination from "react-bootstrap/Pagination";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";

import "./src/css/convenios.css";

import { myBreadCrumbsConv3lv } from './Handlers/BreadCrumbsConv';
import Footer from '../Footer';

import ModalSolicitudDetail from "./Handlers/ModalSolicitudDetail";
import { Button } from "semantic-ui-react";
import ModalSolicitudMod from "./Handlers/ModalSolicitudMod";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const apiURL = process.env.REACT_APP_API_URL;

let activeC: string = "Lista de solicitudes a códigos institucionales"
let paginadorTotal: number;
let institucionAct: number;

const modTool = (p: any) => (
  <Tooltip id="button-tooltip" {...p}>
    Modificar solicitud
  </Tooltip>
);

const modVer = (p: any) => (
  <Tooltip id="button-tooltip" {...p}>
    Ver detalle de solicitud
  </Tooltip>
);

export default observer(function ListaSolicitudes() {
  let items: any = [];

  const { userStore: { user, roles } } = useStore();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowM, setModalShowM] = React.useState(false);
  const [institu, setInstitucion] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [solicitud, setSolicitudes] = useState([]);

  const [loading, setLoading] = useState(false);
  const handlePageClick = (numberPagina: number) => { setCurrentPage(numberPagina) };

  const [soli, setSoli] =
    useState({
      idsol: 0,
      dessol: '',
      nsolic: '',
      nrespo: '',
      crespo: '',
      trespo: 0,
      entsol: '',
      datsol: ''
    });

  const {
    idsol,
    dessol,
    nsolic,
    nrespo,
    crespo,
    trespo,
    entsol,
    datsol,
  } = soli;

  const listaSolicitudes = async () => {
    setLoading(true);

    const url = apiURL + `/CATSolicitudConvenios/${currentPage}/10`;

    const responseConvenio = await axios(url);
    const { data } = responseConvenio;
    paginadorTotal = data.totalPages;

    const solicitudCont = data.records.map((dataR: {
      key: number;
      id: number;
      nombreSolicitante: string;
      nombreResponsable: string;
      telefonoResponsable: number;
      correoResponsable: string,
      descripcion: string;
      sgtEntidad: string;
      createdAt: any;

    }) => {

      return {
        key: dataR.id,
        id: dataR.id,
        nombreSolicitante: dataR.nombreSolicitante,
        nombreResponsable: dataR.nombreResponsable,
        telefonoResponsable: dataR.telefonoResponsable,
        correoResponsable: dataR.correoResponsable,
        descripcion: dataR.descripcion,
        createdAt: dataR.createdAt,
        sgtEntidad: dataR.sgtEntidad
      };

    });
    setSolicitudes(solicitudCont);
    setLoading(false);
  }; useEffect(() => { listaSolicitudes() }, [institu, currentPage]);

  for (
    let numberPagina: any = 1;
    numberPagina <= paginadorTotal;
    numberPagina++
  ) {
    items.push(
      <Pagination.Item
        key={numberPagina}
        active={currentPage === numberPagina}
        activeLabel={""}
        onClick={() => {
          handlePageClick(numberPagina);
        }}
      >
        {numberPagina}
      </Pagination.Item>
    );
  }

  function ropm(
    id: number,
    de: string,
    ns: string,
    nr: string,
    cr: string,
    tr: number,
    en: string,
    da: string,
  ) {
    setSoli({
      ...soli,
      dessol: de,
      idsol: id,
      nsolic: ns,
      nrespo: nr,
      crespo: cr,
      trespo: tr,
      entsol: en,
      datsol: da,
    });
    setModalShow(true);
  }

  function ropm2(
    id: number,
    de: string,
    ns: string,
    nr: string,
    cr: string,
    tr: number,
    en: string,
    da: string,
  ) {
    setSoli({
      ...soli,
      dessol: de,
      idsol: id,
      nsolic: ns,
      nrespo: nr,
      crespo: cr,
      trespo: tr,
      entsol: en,
      datsol: da,
    });
    setModalShowM(true);
  }

  const ConvenioItems = (dataR: {
    key: number;
    id: number;
    nombreSolicitante: string;
    nombreResponsable: string;
    telefonoResponsable: number;
    correoResponsable: string;
    descripcion: string;
    sgtEntidad: string;
    createdAt: any;
  }) => {

    return (

      <Row className="solicitudes-list">
        <Col xs={1} className="solicitud-body-sec indice">{dataR.id}</Col>
        <Col xs={2} className="solicitud-body-sec indice">{calculoFechas(dataR.createdAt)}</Col>
        <Col className="solicitud-body-sec">{dataR.nombreSolicitante}</Col>
        <Col className="solicitud-body-sec">{dataR.nombreResponsable}</Col>
        <Col xs={2} className="solicitud-body-sec-actions">{

          <>

            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={modTool}
            >
              <Button
                className="circular-button edi-sol-but"
                circular
                color='twitter'
                type="button"
                icon={'pencil'}
                onClick={() => ropm2(
                  dataR.id,
                  dataR.descripcion,
                  dataR.nombreSolicitante,
                  dataR.nombreResponsable,
                  dataR.correoResponsable,
                  dataR.telefonoResponsable,
                  dataR.sgtEntidad,
                  dataR.createdAt,
                )}
              />
            </OverlayTrigger>

            {/* <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={modVer}
            >
              <Button
                className="circular-button"
                circular
                color='facebook'
                type="button"
                onClick={() => ropm(
                  dataR.id,
                  dataR.descripcion,
                  dataR.nombreSolicitante,
                  dataR.nombreResponsable,
                  dataR.correoResponsable,
                  dataR.telefonoResponsable,
                  dataR.sgtEntidad,
                  dataR.createdAt,
                )}
                icon={'ellipsis vertical'}
              />
            </OverlayTrigger> */}

          </>

        }
        </Col>
      </Row>

    );
  };

  return (
    <>

      <Container className="solicitudes-area-head head-institu">

        <div className="title-area-institu solicitudes-area-head" >
          <h2>Listado de solicitudes</h2>
        </div>

        <div className="bread-institu-internals">
          {myBreadCrumbsConv3lv(activeC)}
        </div>

      </Container>

      <Container className="convenios-section interior-solicitudes">
        <Container>
          <Row>
            <Col className="buscar-convenio-area">
              <Form.Control placeholder="Buscar código" />
              <Button variant="primary">Buscar</Button>{" "}
            </Col>

            <Col className="crear-convenio-area">
              {/* <Link to="/solicitudes/crear-solicitud">
                <Button variant="success" className="link">
                  Crear nueva solicitud
                </Button>
              </Link> */}
            </Col>
          </Row>
        </Container>

        <Container className="convenio-head-list">
          <Col xs={1} className="convenio-head-section">Id</Col>
          <Col xs={2} className="convenio-head-section">Fecha</Col>
          <Col className="convenio-head-section">Solicitante</Col>
          <Col className="convenio-head-section">Responsable</Col>
          <Col xs={2} className="convenio-head-section">
            Acciones
          </Col>
        </Container>

        <Container className="convenio-body-list solicitudes-body-area">
          {loading ? (
            <LoadingComponent content="Cargando solicitudes..." />
          ) : (

            solicitud.map(
              (solicitud: {
                key: number;
                id: number;
                nombreSolicitante: string;
                nombreResponsable: string;
                telefonoResponsable: number;
                correoResponsable: string;
                descripcion: string;
                sgtEntidad: string;
                createdAt: any;
              }) => (

                <ConvenioItems {...solicitud} />

              )
            )

          )}
        </Container>

        <Container className="pagination-convenios-area">
          <Pagination>{items}</Pagination>
        </Container>

      </Container>

      {/* <ModalSolicitudDetail
        key={idsol}
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        solid={idsol}
        soldes={dessol}
        nsolic={nsolic}
        nrespo={nrespo}
        crespo={crespo}
        trespo={trespo}
        entsol={entsol}
        datsol={datsol}
        ctype={"CATSolicitudConvenio"}
      /> */}

      <ModalSolicitudMod
        key={ idsol }
        onHide={ () => { setModalShowM(false) }}
        show={ modalShowM }
        solid={ idsol }
        soldes={ dessol }
        nsolic={ nsolic }
        nrespo={ nrespo }
        crespo={ crespo }
        trespo={ trespo }
        entsol={ entsol }
        datsol={ datsol }
        ctype={"CATSolicitudConvenio"}
      />

    </>
  );
});

